import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SimpleComponentsModule } from '@app/shared/ui/simple-components/simple-components.module';
import { TopicTypeId } from '@app/origami-api/constants';
import { StatusColorId } from '@app/shared/ui/simple-components/status/status-models';
import { SessionService } from '@app/session/session.service';
import { tiStringsFormat } from '@app/shared/pipes/string-format.pipe';
import { NgIf } from '@angular/common';

export interface SectionMetadata {
  status: 'pending' | 'completed';
  assignedTo: number;
  assignedToName: string;
  completionDate?: string;
}

@Component({
  selector: 'ti-section-metadata',
  standalone: true,
  imports: [SimpleComponentsModule, NgIf],
  templateUrl: './section-metadata.component.html',
  styleUrl: './section-metadata.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionMetadataComponent {
  readonly strings = tiStrings.modules.quality.incidents;
  readonly miscStrings = tiStrings.app.misc;

  protected readonly TopicTypeId = TopicTypeId;

  constructor(private sessionService: SessionService) {}

  @Input() data: SectionMetadata = null;

  get statusId(): number {
    return this.data?.completionDate ? StatusColorId.Green : StatusColorId.Orange;
  }

  get statusName() {
    return this.data?.completionDate ? this.miscStrings.completed : this.miscStrings.pending;
  }

  get text(): string {
    if (!this.data?.assignedTo) return '';

    const name =
      this.sessionService.user.id === this.data?.assignedTo
        ? `${this.data?.assignedToName} (${this.miscStrings.you})`
        : this.data?.assignedToName;
    const base = this.data?.completionDate ? this.strings.sectionCompleted : this.strings.sectionPending;

    return tiStringsFormat(base, name, this.data?.completionDate ? this.data.completionDate : '');
  }
}
